import { PlayCircle } from 'lucide-react';
import { InstagramReelsWidget } from './InstagramReelsWidget';

export function VideosScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="bg-white rounded-2xl border-2 border-gray-200 shadow-sm p-6 mb-8">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-xl bg-dropsugar-green/10">
              <PlayCircle className="w-7 h-7 text-dropsugar-green" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Videos</h1>
              <p className="text-gray-600 mt-1">
                Browse your education and support videos in one place.
              </p>
            </div>
          </div>
        </div>

        <InstagramReelsWidget />
      </div>
    </div>
  );
}
